import { render } from "./GlyueCheckbox.vue?vue&type=template&id=2a40dc1a"
import script from "./GlyueCheckbox.vue?vue&type=script&lang=js"
export * from "./GlyueCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__